import * as React from 'react';
import { CalendarItem as CalendarItemType } from '../../core/typings/api';
import CalendarItem from '../CalendarItem';
import './styles.scss';

interface CalendarItemsListProps {
  items: CalendarItemType[];
}

const CalendarItemsList = ({
  items,
}: CalendarItemsListProps) => (
  <div className="calendar-items-list">
    {items.map((item) => <CalendarItem {...item} />)}
  </div>
);

export default CalendarItemsList;
